const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_1406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 42,
    height: 49
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 4.86133H48.4607V52.8406H7.25V4.86133Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3008 8.48633C14.2964 8.48633 10.971 11.7295 10.8768 15.7291V41.5753C10.7874 45.7151 14.0499 49.125 18.1485 49.2168H37.6365C41.67 49.0501 44.8648 45.6982 44.8358 41.5898V20.154L33.6345 8.48633H18.3298H18.3008ZM18.3307 52.8418H18.0673C11.9724 52.7041 7.11975 47.6339 7.25267 41.5367V15.6856C7.39283 9.68983 12.3446 4.86133 18.2968 4.86133H18.3379H34.4088C34.9018 4.86133 35.373 5.06191 35.7162 5.41716L47.9566 18.1699C48.2804 18.5058 48.4617 18.9577 48.4617 19.4242V41.5753C48.5052 47.6387 43.783 52.5929 37.7099 52.8394L18.3307 52.8418Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6354 21.711H39.9775C35.555 21.6989 31.959 18.0933 31.959 13.6756V6.64551C31.959 5.64501 32.771 4.83301 33.7715 4.83301C34.772 4.83301 35.584 5.64501 35.584 6.64551V13.6756C35.584 16.1019 37.5584 18.0788 39.9823 18.086H46.6354C47.6359 18.086 48.4479 18.898 48.4479 19.8985C48.4479 20.899 47.6359 21.711 46.6354 21.711Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3234 38.9258H20.2734C19.2729 38.9258 18.4609 38.1138 18.4609 37.1133C18.4609 36.1128 19.2729 35.3008 20.2734 35.3008H33.3234C34.3239 35.3008 35.1359 36.1128 35.1359 37.1133C35.1359 38.1138 34.3239 38.9258 33.3234 38.9258Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3779 29.8584H20.2676C19.2671 29.8584 18.4551 29.0464 18.4551 28.0459C18.4551 27.0454 19.2671 26.2334 20.2676 26.2334H28.3779C29.3784 26.2334 30.1904 27.0454 30.1904 28.0459C30.1904 29.0464 29.3784 29.8584 28.3779 29.8584Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaper);
export default __webpack_public_path__ + "static/media/icon-paper.a4a12c0803682a1a89e14767f33e2292.svg";
export { ForwardRef as ReactComponent };